/* globals cpac,
    showResources, $,
    parceCourtGreed, $j, timeToFloat,
    nameFieldOnFocus, floatToTime,
    timeFormatDbTimeFullToJsDate,
    jsDateTo12hTime, showAjaxStarted,
    showResponse, reportAjaxError, Ajax */

if (typeof cpac !== 'undefined') {
    cpac.resource = {};

    // these two objects are globals because court-schedule.phtml
    // and attendance-pro-court-schedule.phtml expect them to be
    window.colName = [];
    window.courtGridStep = 0.5;

    if (typeof(cpac.resource.name) === 'undefined') {
        cpac.resource.name = 'court';
    }

    cpac.resource.selectPro = {
        activeTime : null

       ,onTimeClick: function( e, sender, baloon ) {
           if( this.activeTime ) {
               this.activeTime.getPopup().hide();
           }

           this.activeTime = new cpac.resource.selectPro.Time( $j( sender ), baloon);
           this.activeTime.click();

           if( e && e.stopPropagation ) {
               e.stopPropagation();
           } else if (e){
               e.cancelBubble = true;
           }
       }
       ,onAddPro: function( sender ) {
           this.activeTime.addPro( $j( sender ));
       }
       ,onClosePopup: function() {
           if( this.activeTime ) {
               this.activeTime.getPopup().hide();
               if (this.activeTime.getPopup().type == 'new') {
                   this.onDeleteTime();
               }
           }
       }
       ,onPreventPro: function() {
           this.activeTime.noPro();
       }
       ,onResize: function( sender ) {
           var border = $j( sender );
           var block = border.parent();

           var time = new cpac.resource.selectPro.Time( block );
           if( time.resizable() ) {
               border.mouseover();
           }
       }
       ,onClickEmpty: function(e, sender ) {
           var cell = new cpac.resource.selectPro.Cell( $j(sender) );

           if( cell.isDisabled() || ! cell.isFree() ) {
               return false;
           }

           // fill all available cells
           var topCell = cell.getMaxTopCell();
           var lowCell = cell.getMaxLowCell();

           var step = courtGridStep || 0.5;
           var duration = timeToFloat( lowCell.getTime() ) - timeToFloat( topCell.getTime() ) + step;

           topCell.addProTime(e,  duration );
       }
       ,onDeleteTime: function() {
           if( this.activeTime ) {
               this.activeTime.getPopup().hide();
               this.activeTime.getCell().el.find('.wrapEvent').empty();
           }
       }
       ,onDeletePro: function() {
           if( this.activeTime ) {
               this.activeTime.delPro();
               this.activeTime = new cpac.resource.selectPro.Time( this.activeTime.el );
               this.activeTime.click();
           }
       }
       ,onDrag: function( sender ) {
           var header = $j(sender);
           var block = header.parent().parent();

           var time = new cpac.resource.selectPro.Time( block );
           if( time.draggable() ) {
               header.mouseover();
           }
       }
       ,transPopupClick: function(event) {
           var x = event.clientX;
           var y = event.clientY;

           if( document.elementFromPoint ) {
               if( this.activeTime ) {
                   this.activeTime.getPopup().hide();
                   var el = document.elementFromPoint(x, y);
                   if( el ) {
                       $j(el).click();
                   }
               }
           }
       }
       ,onSave: function( url ) {
           if( this.activeTime ) {
               this.activeTime.getPopup().hide();
           }

           showAjaxStarted();
           var parameters = {};
           var cells  = $j( '#courtsInfo table#content td' );
           var courts = {};
           cells.each(function(i, el){
               var cell = new cpac.resource.selectPro.Cell( $j( el ));
               if( cell && cell.getCourt() ) {
                   if( courts[ cell.getCourt() ] === undefined ) {
                       courts[ cell.getCourt() ] = [];
                   }
                   if( cell.hasEventBlock() ) {
                       var time = cell.getProTime();
                       if( time && time.serialize ) {
                           courts[ cell.getCourt() ].push( time.serialize() );
                       }
                   }
               }
           });

           parameters['data'] = Object.toJSON(courts);
           $j('#courtScheduleProperties').find('input').each(function () {
               parameters[$j(this).attr('id')] = $j(this).val();
           });

           var ajaxDiv = $('courtsInfo');
           url += url.indexOf('?') > -1 ? '&ajax=true' : '?&ajax=true';
           new Ajax.Request( url, {
               method: 'post',
               parameters: parameters,
               onComplete: function(response) {
                   if (response.responseText.indexOf('staff-availability-overriding') > 0) {
                       showResponseInModal(response, 'Staff Not Available', 425, 100);
                   } else {
                       showResponse(response, ajaxDiv);
                   }
               },
               onFailure: reportAjaxError
           });
       }
   }

    cpac.resource.selectPro.Popup = (function(){
        var Popup = function( time ) {
            this.time = time;
            this.el = $j('#new-pro');
            this.type = 'default';

            // Interface
            this.show = function() {this._show();}
            this.hide = function() {this._hide();}

            // Implementation
            this._show = function() {
                var pop = this.el;
                var pos = this.time.el.offset();
                var viewPort = this.getViewport();
                var popHeight = Element.getHeight(pop.get(0));
                var popWidth = Element.getWidth(pop.get(0));
                var newTop = pos.top - popHeight + 13;
                var newLeft =  pos.left + time.el.width() - 33;
                if (newLeft + popWidth > viewPort.l + viewPort.w) {
                    newLeft = pos.left - popWidth + 33;
                    var tail = $j('div.tail', pop).get(0);
                    if (tail) {
                        tail.className = 'tail reverse';
                    }
                } else {
                    tail = $j('div.tail', pop).get(0);
                    if (tail) {
                        tail.className = 'tail';
                    }
                }
               // if (newLeft < viewPort.l) {
               //     newLeft = pos.left + this.offsetWidth
               // }
                pop.css('top', newTop );
                pop.css('left', newLeft );
                var hidePopup = function (ev) {
                    if (ev.target != ev.data.trigger &&
                        ev.data.pop.get(0) != ev.target &&
                        !$j.contains(ev.data.pop.get(0), ev.target)) {
                        ev.data.trigger.hide();
                        $j(document).off('mousedown', hidePopup);
                    }
                }
                $j(document).on('mousedown', {pop: pop, trigger: this}, hidePopup);

                if(pop.position().top <= 40) {
                    $j(tail).prependTo('#court-info-div');
                    $j(tail).addClass('top');
                    pop.find('#ballon-eventInfo').addClass('top');
                    pop.css('top', newTop + popHeight);
                }


            }

            this._hide = function() {
                this.el.css('top', -1000 );
                this.el.css('left', -1000 );
            }

            this.getViewport = function () {
                var m = document.compatMode == 'CSS1Compat';
                return {
                    l : window.pageXOffset || (m ? document.documentElement.scrollLeft : document.body.scrollLeft),
                    t : window.pageYOffset || (m ? document.documentElement.scrollTop : document.body.scrollTop),
                    w : window.innerWidth || (m ? document.documentElement.clientWidth : document.body.clientWidth),
                    h : window.innerHeight || (m ? document.documentElement.clientHeight : document.body.clientHeight)
                };
            }
        }
        var popup = new Popup();

        /**
         *
         * @param el
         */
        var NewPro = function( time ) {
            Popup.call( this, time );
            this.el = $j('#new-pro');
            this.type = 'new';

            //
            this.show = function() {
                var txt = $j('input.add_pro_input', this.el);
                if( !txt.data('events') || !txt.data('events').focus ) {
                    txt.focus(function(){
                        if( txt.val() == 'Add a pro' ) txt.val('');
                        var component_id  = null;
                        var group = 'staff';
                        if(txt.data('component_id') != '') {
                            component_id = txt.data('component_id');
                            group = null;
                        }
                        nameFieldOnFocus(this,'staff_id', group, null,null,null,null, null, null, component_id);
                    });
                }
                if( !txt.data('events').blur ) {
                    txt.blur(function(){
                        if( txt.val() == '') txt.val('Add a pro');
                    });
                }

                var court_id = this.time.getCell().getCourt();
                if(colName && colName[ court_id ] ) {
                    this.setTitle( colName[ court_id ] );
                }

                this._show();
            }

            //
            this.hide = function() {
                $j('#staff_name').val('Add a pro').removeClass('ac_field').blur();
                $j('#staff_id').val('');

                this._hide();
            }

            //
            this.setTitle = function( text ) {
                $j('.title b', this.el ).html( text );
            }
        }
        NewPro.prototype = popup;

        /**
         *
         * @param el
         */
        var EditPro = function( time ) {
            Popup.call( this, time );
            this.el = $j('#edit-pro');
            this.type = 'pro';

            this.show = function() {
                $j('.fb-user-box-title', this.el).html( this.time.getTitle() );
                this.setTitle();
                this._show();
            }

            //
            this.setTitle = function() {
                var court_id = this.time.getCell().getCourt();
                var title = '';
                if( colName && colName[ court_id ] ) {
                    title += colName[ court_id ]+' ';
                }

                var from = timeToFloat( this.time.getCell().getTime() );
                var to = from + this.time.getDuration();

                var dateFrom = timeFormatDbTimeFullToJsDate( floatToTime( from )+':00' );
                var dateTo   = timeFormatDbTimeFullToJsDate( floatToTime( to )+':00' );

                from = jsDateTo12hTime( dateFrom, true );
                to = jsDateTo12hTime( dateTo, true );

                var t = '';
                t += parseInt(from.h, 10)+'';
                t += from.m == '00' ? '' : ':'+from.m;
                t += from.f == to.f ? '' : from.f;
                t += '-'+parseInt(to.h, 10);
                t += to.m == '00' ? '' : ':'+to.m;
                t += to.f;

                $j('.title b', this.el ).html( title );
                $j('.title span', this.el ).html( t );
            }
        }
        EditPro.prototype = popup;

        /**
         *
         * @param el
         */
        var NoPro = function( time ) {
            Popup.call( this, time );
            this.el = $j('#no-pro');
            this.type = 'no-pro';

            this.show = function() {
                this.setTitle();
                this._show();
            }
        }
        NoPro.prototype = new EditPro();

        /**
         *
         * @param el
         */
        var Custom = function( time, baloon ) {
            Popup.call( this, time );
            this.el = $j(baloon);
            this.type = 'custom';

            this.show = function() {
                this.setTitle();
                this._show();
            }
            this.setTitle = function() {
                var titleObj = $j('h4', this.el).get(0);
                if(titleObj) {
                    var title = titleObj.innerHTML;
                    titleObj.parentNode.removeChild(titleObj);
                    $j('div.ballon-title>b', this.el).html( title );
                }

                //$j('h4>div', this.el).html( 'smth' );
            }
            this.hide = function() {
                this._hide();
            }
        }
        Custom.prototype = popup;

        return function( time, baloon ) {
            if( time.el.hasClass('event-type-ghost-pro')) {
                return new NewPro( time );
            }
            else if( time.el.hasClass('event-type-active-pro')) {
                return new EditPro( time );
            }
            else if( time.el.hasClass('event-type-prevent-pro')) {
                return new NoPro( time );
            }
            else if (baloon != undefined && baloon) {
                return new Custom( time, baloon );
            }
            else {
                return new Popup( time );
            }
        }
    })();

   /**
   * Select a Pro Time Factory
   */
   cpac.resource.selectPro.Time = (function() {
       /**
        * Abstract Time
        */
       var Time = function( el, baloon ) {
           // Constructor
           if( el ) {
               this.el = el;
           }
           this.baloon = baloon;

           // Interface
           this.click = function() {}
           this.addPro = function() {}
           this.noPro = function() {}
           this.delPro = function() {}

           /**
            *
            */
           this.resizable = function() {
               if( ! this.el.hasClass('ui-resizable')) {
                   var time = this;
                   this.el.resizable({
                       handles: {s: '.border-bottom'}
                      ,grid: this.getCell().getGridHeight()
                      ,start: function() {
                           var cell = time.getCell();
                           var step = courtGridStep || 0.5;
                           var maxHeight;

                           var after = time.getCellAfter();
                           if( after == null || !after.isFree() || after.isDisabled() ) {
                               maxHeight = time.getDuration() * cell.getGridHeight() * (1 / courtGridStep);
                           } else {
                               var startTime = timeToFloat( cell.getTime() );
                               var stopTime  = timeToFloat( after.getMaxLowCell().getTime() );
                               maxHeight = (stopTime - startTime + step) * cell.getGridHeight() * (1 / courtGridStep);
                           }

                           $j(this).resizable('option', 'maxHeight', maxHeight );
                      }
                      ,stop: function( event, ui ) {
                           var duration = ui.element.height() / time.getCell().getGridHeight() / (1 / courtGridStep)
                           time.el.attr('data-duration', duration);
                      }
                   });

                   return true;
               }
               return false;
           }

           /**
            *
            */
           this.draggable = function() {
               if( ! this.el.hasClass('ui-draggable')) {
                   var time = this;

                   this.el.draggable({
                       handle: 'h4'
                      ,axis: 'y'
                      ,grid: [ this.getCell().getGridHeight(), this.getCell().getGridHeight() ]
                      ,start: function() {
                           var cell = time.getCell();
                           var topCell = cell.getMaxTopCell();
                           var minPos = topCell.el.offset();
                           var minX = minPos.left;
                           var minY = minPos.top;

                            var lowCell,
                                maxPos,
                                maxX,
                                maxY;

                           var after = time.getCellAfter();
                           if( after == null || !after.isFree() || after.isDisabled() ) {
                               lowCell = cell;
                               maxPos = lowCell.el.offset();
                               maxX = maxPos.left;
                               maxY = maxPos.top;
                           } else {
                               lowCell = after.getMaxLowCell();
                               maxPos = lowCell.el.offset();
                               maxX = maxPos.left;
                               maxY = maxPos.top;
                               maxY -= time.getDuration() * (1 / courtGridStep) * cell.getGridHeight() - cell.getGridHeight();
                           }

                           $j(this).draggable('option', 'containment', [ minX, minY, maxX, maxY ]);
                      }
                      ,revert: function() {
                           var cell = time.getCell();
                           var ui = $(this).data("uiDraggable")._uiHash();
                           ui.originalPosition.left = 0;
                           ui.originalPosition.top = 0;
                           ui.position.left = 0;

                           var timeShift = ui.position.top / cell.getGridHeight() / (1 / courtGridStep);
                           var newTime = timeToFloat( cell.getTime() ) + timeShift;
                           var newId = cell.getIdByParams(cell.getCourt(), floatToTime(newTime), cell.getColNumber());
                           var newCell = cell.getCellById( newId );

                           if( newCell && newCell.isFree( time )) {
                               $j('.wrapEvent', newCell.el ).append( time.el );
                               time.el.css('top', 0);
                               cell.el.find('.wrapEvent').empty();

                               return false; // is ok
                           } else {
                               return true; // revert
                           }
                      }
                   });

                   return true;
               }
               return false;
           }

           this.getDuration = function() {
               var i = parseFloat( this.el.attr('data-duration'));
               return isNaN(i) ? 0 : i;
           }

           this.getProId = function() {
               var i = parseInt( this.el.attr('data-pro-id'));
               return isNaN(i) ? 0 : i;
           }

           this.getCell = function() {
               var td = this.el.parent().parent();
               if( td.is('td') ) {
                   return new cpac.resource.selectPro.Cell( td );
               }
           }

           this.getCellAfter = function() {
               var startCell = this.getCell();
               var endTime = floatToTime( timeToFloat( startCell.getTime() ) + this.getDuration() );
               var endCellId = startCell.getIdByParams(startCell.getCourt(), endTime, startCell.getColNumber());
               var endCell = startCell.getCellById( endCellId );

               return endCell;
           }

           this.setTitle = function( text ) {
               $j('h4>div', this.el).html( text );
           }

           this.getTitle = function() {
               return $j('h4>div', this.el).html();
           }

           this.getPopup = function(baloon) {
               if (baloon == undefined) {
                   baloon = this.baloon;
               }
               var popup = new cpac.resource.selectPro.Popup( this, baloon );
               return popup;
           }
       }
       var time = new Time();

       /**
        * Ghost Time (gray box)
        */
       var Ghost = function(el) {
           Time.call( this, el );

           this.click = function() {
               this.getPopup().show();
           }

           this.addPro = function() {
               var id   = $j('#staff_id').val();
               var name = $j('#staff_name').val();

               this.setTitle( name );
               this.el.attr('data-pro-id', id);

               this.getPopup().hide();
               this.el.removeClass('event-type-ghost-pro');
               this.el.addClass('event-type-active-pro');
           }

           this.noPro = function() {
               this.setTitle('No Pro');
               this.getPopup().hide();
               this.el.removeClass('event-type-ghost-pro');
               this.el.addClass('event-type-prevent-pro');
           }
       }
       Ghost.prototype = time;

       /**
        * Active Time (blue box)
        */
       var Active = function(el) {
           Time.call( this, el );

           this.click = function() {
               this.getPopup().show();
           }

           this.delPro = function() {
               this.getPopup().hide();
               this.el.removeAttr('data-pro-id');
               this.el.removeClass('event-type-active-pro');
               this.el.addClass('event-type-ghost-pro');
           }

           this.serialize = function() {
               var time = this;
               var cell = this.getCell();
               return {
                   pro: time.getProId()
                  ,time: cell.getTime()
                  ,hours: time.getDuration()
                  ,court: cell.getCourt()
               }
           }
       }
       Active.prototype = time;

       /**
        * Prevent Time (red box)
        */
       var Prevent = function(el) {
           Time.call( this, el );

           this.click = function() {
               this.getPopup().show();
           }

           this.serialize = function() {
               var time = this;
               var cell = this.getCell();
               return {
                   pro: 0
                  ,time: cell.getTime()
                  ,hours: time.getDuration()
                  ,court: cell.getCourt()
                  ,noPro: true
               }
           }
       }
       Prevent.prototype = time;

       /**
        * Custom Time (for tennis courts)
        */
       var Custom = function( el, baloon ) {
           Time.call( this, el, baloon );

           this.click = function() {
               this.getPopup(baloon).show();
           }

           this.serialize = function() {
               var time = this;
               var cell = this.getCell();
               return {
                   pro: 0
                  ,time: cell.getTime()
                  ,hours: time.getDuration()
                  ,court: cell.getCourt()
                  ,noPro: true
               }
           }
       }
       Custom.prototype = time;

       return function( el, baloon ) {
           if( el.hasClass('event-type-ghost-pro')) {
               return new Ghost( el, baloon );
           }
           else if( el.hasClass('event-type-active-pro')) {
               return new Active( el, baloon );
           }
           else if( el.hasClass('event-type-prevent-pro')) {
               return new Prevent( el, baloon );
           }
           else if (baloon != undefined && baloon) {
               return new Custom (el, baloon);
           }
           else {
               return new Active( el, baloon );
           }
       }
   })();

   cpac.resource.selectPro.Cell = function( el ) {
       this.el = el;

       this.getGridHeight = function() {
           return 20;
       }

       this.isDisabled = function() {
           return this.el.hasClass('blackout');
       }

       this.getId = function() {
           var id = this.el.attr('id');
           return typeof(id) == 'undefined' ? '' : id;
       }

       this.getTime = function() {
           return this.el.data('time');
       }

       this.getCourt = function() {
           return this.el.data('court-id');
       }

       this.getTrainer = function() {
           return this.el.data('trainer-id');
       };

       this.getColNumber = function() {
           return this.el.data('col-number');
       };

       this.getCellById = function( id ) {
           var jc = $j( document.getElementById( id ));
           if( jc.is('td') ) {
               return new cpac.resource.selectPro.Cell( jc );
           }
           return null;
       }

       this.getIdByParams = function(courtId, time, colNumber) {
           return 'court_' + courtId + '_row_' + time + '_col_' + colNumber;
       };

       this.hasEventBlock = function() {
           return this.el.find('.eventBlock').length > 0;
       }

       this.isFree = function( TimeEventToExcept ) {
           if( this.hasEventBlock() ) {
               return false;
           }
           var cell = this;
           while( cell = cell.getTopCell() ) {
               if( cell.hasEventBlock() ) {
                   if( TimeEventToExcept ) {
                       var cellTime = cell.getProTime();
                       if( cellTime.el[0] == TimeEventToExcept.el[0] ) {
                           return true;
                       }
                   }
                   var d = cell.getProTime().getDuration();
                   var start = timeToFloat( cell.getTime() );
                   var end = timeToFloat( this.getTime() );
                   var busy = start + d > end;
                   return !busy;
               }
           }

           return true;
       }

       this.getTopCell = function() {
           var step = courtGridStep || 0.5;
           var time = floatToTime( timeToFloat( this.getTime() ) - step);
           var colNumber = this.getColNumber();
           var id = this.getIdByParams( this.getCourt(), time, colNumber);
           var cell = this.getCellById( id );
           return cell;
       }

       this.getLowCell = function() {
           var step = courtGridStep || 0.5;
           var time = floatToTime( timeToFloat( this.getTime() ) + step);
           var colNumber = this.getColNumber();
           var id = this.getIdByParams( this.getCourt(), time, colNumber);
           var cell = this.getCellById( id );
           return cell;
       }

       this.getMaxTopCell = function() {
           var _cell;
           var newCell = this;
           while(_cell = newCell.getTopCell()) {
               if( !_cell.isDisabled() && _cell.isFree()  ) {
                   newCell = _cell;
               }
               else break;
           }
           return newCell;
       }

       this.getMaxLowCell = function( ) {
           var _cell;
           var newCell = this;
           while(_cell = newCell.getLowCell()) {
               if( !_cell.isDisabled() && _cell.isFree()  ) {
                   newCell = _cell;
               }
               else break;
           }
           return newCell;
       }

       this.getProTime = function() {
           var e = this.el.find('.eventBlock');
           var t = new cpac.resource.selectPro.Time(e);
           return t;
       }

       this.addProTime = function(e, duration, type, title )
       {
           if( !type ) {
               type = 'ghost-pro';
           }
           if( !title ) {
               title = 'add item';
           }
           var block = $j('.wrapEvent', this.el ).append(
             '<div class="eventBlock event-type-'+type+'" onclick="cpac.resource.selectPro.onTimeClick(event, this)">'
           +     '<h4><div>'+title+'</div></h4>'
           +     '<div>&nbsp;</div>'
           +     '<a class="border-bottom ui-resizable-handle ui-resizable-s"></a>'
           + '</div>').find('div.eventBlock');

           block.attr('data-duration', duration);

           var time = new cpac.resource.selectPro.Time( block );
           time.resizable();
           time.draggable();

           block.height( this.getGridHeight() * duration * (1 / courtGridStep) );

           if (e) {
               cpac.resource.selectPro.onTimeClick(e, block);
           }

           return time;
       }
   }


  cpac.resource.updateTrainerSchedule = function(sender) {
    var baseUrl = '/';
    var url = baseUrl;

    if( sender.id == 'pro-scheduling-button' ) {
        cpac.tennis.toggleReserveButtons(sender.id);
        $(sender).toggleClassName('active');
        if( $(sender).hasClassName('active') )
        {
            url += 'user/staff-schedule/?doFilter=1&onlygrid=true&edit=1'+( $('date') ? '&date='+$('date').value : '' )+( $('group_location_id') ? '&form_group_id='+$('group_location_id').value : '' );
            showResources( $('courtScheduleProperties'), url, 'court-properties-container');
        } else {
            url += 'user/staff-schedule/?doFilter=1&onlygrid=true'+( $('date') ? '&date='+$('date').value : '' ) + ( $('group_location_id') ? '&form_group_id='+$('group_location_id').value : '' );
            showResources( null, url, 'court-properties-container', function(){
                showResources($('courtScheduleProperties'), baseUrl+'resource/human-schedule' + ( $('group_location_id') ? '?by_group_id='+$('group_location_id').value : '' ), 'courtsInfo');
            });
        }
        return;
    }

    var toggleEditButton = false;

    url += 'user/staff-schedule?onlygrid=true&doFilter=1';

    if( sender.id == 'add_user_id' ) {
        url += '&edit=1&new_staff_id='+sender.value;
    }

    if( sender.id == 'date' ) {
        url += '&date_change=1&edit=1';
    }

    if( sender.id == 'save' ) {
        url += '&save=1';
        toggleEditButton = true;
    }

    if( sender.id == 'copy-week-from-date-button' ) {
        url += '&date_change=1&copy=week&copy-from='+$('copy-from-date').value;
        showResources( $('courtScheduleProperties'), url, 'court-properties-container', function(){
            cpac.tennis.toggleReserveButtons('');
            showResources($('courtScheduleProperties'), baseUrl+'resource/human-schedule' + ( $('group_location_id') ? '?by_group_id='+$('group_location_id').value : '' ), 'courtsInfo');
        });
        return;
    }

    if( sender.id == 'copy-from-date-button' ) {
        url += '&date_change=1&copy-from='+$('copy-from-date').value;
        showResources( $('courtScheduleProperties'), url, 'court-properties-container', function(){
            cpac.tennis.toggleReserveButtons('');
            showResources($('courtScheduleProperties'), baseUrl+'resource/human-schedule' + ( $('group_location_id') ? '?by_group_id='+$('group_location_id').value : '' ), 'courtsInfo');
        });
        return;
    }

    if( $('courtScheduleProperties') )
    {
        parceCourtGreed( $('courtScheduleProperties').multiselectdata, true );
        $('courtScheduleProperties').trainers.value = $j('#add_user_list').val();
        showResources( $('courtScheduleProperties'), url, 'court-properties-container');
        if (toggleEditButton) {
            cpac.tennis.toggleReserveButtons('');
        }
    }
  }
}
